import { Component, Input, OnChanges } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormComponent } from '../../../../../models/FormComponent';
import { Product } from '../../../../../models/Product';
import { ProductValidatorService, ValidationErrorSettings } from "../../../../../services/validators/product-validator.service";
import { ProductService } from '../../../../../services/product.service';

@Component({
  selector: 'app-ape-unit-info',
  templateUrl: './ape-unit-info.component.html',
  styleUrls: ['./ape-unit-info.component.scss']
})
export class ApeUnitInfoComponent extends FormComponent implements OnChanges {
  @Input('product') product: Product; //assigned a COPY so that original is maintained to check diff.
  @ViewChild('formElement') formElement:ElementRef;
  @ViewChild('formData') formData:NgForm;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }
  unitInfos: string[];

  constructor(
    private productService:ProductService,
    private _productValidator:ProductValidatorService
  ) { super() }

  ngOnInit(){
    let validationSettings:ValidationErrorSettings = {fieldNameForMessage:'Unit Info', required:false, minlength:4}
    this.initParent(this.product, this.formElement, this.formData, this._productValidator, validationSettings);
  }

  ngOnChanges() {
    //ensure products have been loaded (and thus we can build a list of product categories)
    if(!this.product){
      return;
    }    
    //query product services for list of unit infos
    this.unitInfos = this.productService.knownUnitInfos();
  }


  //===================
  //User Interactions

  dropdownItemClicked($e){
    $e.preventDefault();  //don't follow link
    let unitInfoItem = $e.target.name;
    this.product.product_unit_info = unitInfoItem;
    this.onFormChange(unitInfoItem);
  }


}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-unit-info/ape-unit-info.component.ts